import { render, staticRenderFns } from "./Deletion.vue?vue&type=template&id=7c193a5b&scoped=true&"
import script from "./Deletion.vue?vue&type=script&lang=js&"
export * from "./Deletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c193a5b",
  null
  
)

export default component.exports